import { ChangeEvent } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { Checkbox } from 'uiToolkitV1/Checkbox';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export interface Row {
  label: string;
  value?: string | number | boolean;
  checked?: boolean;
  disabled?: boolean;
}

export interface SelectionGridProps {
  headers: string[];
  rows: Row[][];
  onChange?: (checked: boolean, i: number, j: number) => void;
}

export const SelectionGridTable = ({ headers, rows, onChange }: SelectionGridProps) => (
  <Box bgColor="surface.FDFDFD" borderColor="border.EBEFF3" borderWidth="1px" borderRadius="4px" p={3}>
    <Flex justifyContent="space-between" p="10px 12px" borderRadius="4px" bgColor="surface.F5F7F9">
      {headers.map((header) => (
        <TextBodyMedium flex={1} color="text.g1">
          {header}
        </TextBodyMedium>
      ))}
    </Flex>
    <Box>
      {rows.map((row, i) => (
        <Flex justifyContent="space-between" p="10px 12px" mt={4}>
          {row.map((item, j) => (
            <Box flex={1} key={`${item.label}-${j}`}>
              <Checkbox
                isChecked={item.checked}
                // @ts-ignore
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked, i, j)}
                isDisabled={item.disabled}
              >
                {item.label}
              </Checkbox>
            </Box>
          ))}
        </Flex>
      ))}
    </Box>
  </Box>
);
